import { render, staticRenderFns } from "./FooterComponentEdunet.vue?vue&type=template&id=45ced1ad&scoped=true"
import script from "./FooterComponentEdunet.vue?vue&type=script&lang=ts"
export * from "./FooterComponentEdunet.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentEdunet.vue?vue&type=style&index=0&id=45ced1ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ced1ad",
  null
  
)

export default component.exports